import { useContext } from 'react';

import { ServiceIdentifier } from 'inversify';

import { IocContext } from './IocContext';

export function useInject<T>(identifier: ServiceIdentifier<T>) {
  const container = useContext(IocContext);

  if (!container) {
    throw new Error('Ioc container is empty');
  }

  return container.get<T>(identifier);
}
